import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLogoutMutation } from "../../../api/authApi";
import { reset as resetCredentials } from "../../../store/global/authSlice";
import Box from "@mui/material/Box";
import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import {
    Avatar,
    Badge,
    Button,
    Chip,
    CircularProgress,
    Divider,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Typography,
} from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const dropdownProps = {
    elevation: 0,
    sx: {
        overflow: "visible",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
        },
    },
};

function MeContainer(props) {
    const [logout, { isLoading }] = useLogoutMutation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleClick = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleOnClickLogout = async () => {
        try {
            const result = await logout().unwrap();
            console.log("logout", result);
            dispatch(resetCredentials());
        } catch (error) {
            console.log("cannot logout");
        }
    };

    // logout status
    if (isLoading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {/** me toggle button */}
            <Button onClick={handleClick}>
                <Badge
                    variant="dot"
                    overlap="circular"
                    color="success"
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                >
                    <Avatar alt={user?.text_name} size="small" sx={{ backgroundColor: deepOrange[500] }}>
                        {user?.text_name[0] ?? "??"}
                    </Avatar>
                </Badge>
            </Button>
            {/** me dropdown */}
            <Menu
                anchorEl={anchorEl}
                id="header-account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={dropdownProps}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <Typography variant="body1" fontWeight="bold" margin={2}>
                    {user?.text_name}
                </Typography>
                <Divider />
                <MenuItem disabled={true}>
                    <ListItemIcon>
                        <Settings fontSize="small" />
                    </ListItemIcon>
                    Settings
                </MenuItem>
                <MenuItem onClick={handleOnClickLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </Box>
    );
}

export default MeContainer;
